/**
 * Which layer new work goes on (SRS C8).
 *
 * Two choices, because the paper underneath is not somewhere work can be put. Anything
 * drawn while "Only you" is chosen goes on the teacher-only layer: it never reaches a
 * student's screen, and it never appears in anything a student takes away.
 *
 * Only the teacher sees this control at all, which is why the labels are written from
 * her side of the board rather than named after the layers themselves.
 */

import type { Layer } from '@opal/shared';

import { LAYER_LABELS, WORK_LAYERS } from '../../board/board-layers.js';
import { useBoardStore } from '../../board/store.js';

const HINTS: Readonly<Record<Layer, string>> = {
  content: 'Everything you draw is part of the lesson and the class can see it.',
  teacher: 'What you draw now is yours alone. Students never see it, on screen or in anything they take away.',
};

export function LayerPicker() {
  const activeLayer = useBoardStore((state) => state.activeLayer);
  const setActiveLayer = useBoardStore((state) => state.setActiveLayer);

  return (
    <section className="flex flex-col gap-2">
      <h3 className="text-sm font-medium text-text-secondary">Who sees this</h3>
      <div className="flex gap-2">
        {WORK_LAYERS.map((layer) => {
          const active = activeLayer === layer;
          return (
            <button
              key={layer}
              type="button"
              aria-pressed={active}
              onClick={() => {
                setActiveLayer(layer);
              }}
              className={`min-h-touch flex-1 rounded-md border px-2 text-sm transition-colors duration-fast ${
                active
                  ? 'border-primary bg-primary-subtle text-primary'
                  : 'border-border bg-surface text-text-primary hover:bg-surface-hover'
              }`}
            >
              {LAYER_LABELS[layer]}
            </button>
          );
        })}
      </div>
      <p className="text-xs text-text-secondary">{HINTS[activeLayer]}</p>
    </section>
  );
}
